import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router} from '@angular/router';
import { User, UserRole } from '../models/users';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const allowedRoles = route.data['roles'] as UserRole[] | undefined;

    // If the route does not declare role restrictions, allow access.
    if (!Array.isArray(allowedRoles) || allowedRoles.length === 0) {
      return true;
    }

    const storedUser = localStorage.getItem('logged_in_agent');
    if (!storedUser) {
      this.router.navigate(['/login']);
      return false;
    }

    let user: User | null = null;
    try {
      user = JSON.parse(storedUser) as User;
    } catch {
      this.router.navigate(['/login']);
      return false;
    }

    const userRole = user?.role;
    if (userRole && allowedRoles.includes(userRole)) {
      return true;
    }

    this.router.navigate(['/layout']);
    return false;
  }
}
